import React from 'react'
import getTransitionStyle from '../utils/getTransitionStyle'
import Footer from '../components/Footer'
import Menu from '../components/Menu'
import Link from '../components/IntlLink'
import PageAnimations from '../components/PageAnimations'
import Img from 'gatsby-image'
import { HelmetDatoCms } from 'gatsby-source-datocms'

export default class About extends React.Component {
  render() {
    const {
      data: {
        about: {
          title,
          mainContent,
          teamTitle,
          teamContent,
          teamImage,
          officesTitle,
          officesContent,
          officesImage,
        }
      }
    } = this.props;

    const { data } = this.props;

    const status = this.props.transition ? this.props.transition.status : "entering"
    const menuStyle = getTransitionStyle(status, 200, 2000, 'menuStyle')
    const timeout = 800
    const delay = 1000

    const sectionAppears = getTransitionStyle(
      status, timeout, 1000, 'pageAppearsFromBottom'
    )

    return(
      <div
        className="page"
        style={{ backgroundColor: data.page.themeColor.hex }}
      >
        <HelmetDatoCms
          seo={data.page.seo}
          favicon={data.site.favicon}
        />

        <Menu
          style={menuStyle}
          hasWhiteLogo={true}
          data={this.props.data}
        />

        <PageAnimations
          status={status}
          timeout={timeout}
          delay={timeout}
          color={data.page.themeColor.hex}
        />

        <div className="page__wrapper">
          <h1 className="page__title--white" style={sectionAppears}>
            {title}
          </h1>
          <div className="wrap">
            <div className="page__textbox" style={sectionAppears}>
              <div
                style={sectionAppears}
                className="page__text"
                dangerouslySetInnerHTML={{ __html: mainContent.markdown.html }}
              />
            </div>
          </div>
          <div className="page__section" style={sectionAppears}>
            <div className="page__textbox" style={sectionAppears}>
              <div className="page__image__container">
                <h1 className="page__title--about" style={sectionAppears}>
                  {officesTitle}
                </h1>
                <Img
                  sizes={officesImage.sizes}
                  title={teamImage.title}
                  alt={teamImage.alt}
                />
              </div>
              <div className="wrap">
                <div
                  style={sectionAppears}
                  className="page__text"
                  dangerouslySetInnerHTML={{ __html: officesContent.markdown.html }}
                />
              </div>
            </div>
          </div>
          <div className="page__section page__section--last" style={sectionAppears}>
            <div className="page__textbox" style={sectionAppears}>
              <div className="page__image__container">
                <h1 className="page__title--about" style={sectionAppears}>
                  {teamTitle}
                </h1>
                <Img sizes={teamImage.sizes}
                  title={teamImage.title}
                  alt={teamImage.alt}
                />
              </div>
              <div className="wrap">
                <div
                  style={sectionAppears}
                  className="page__text"
                  dangerouslySetInnerHTML={{ __html: teamContent.markdown.html }}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer data={this.props.data} />
      </div>
    )
  }
}

export const query = graphql`
  query AboutQuery($locale: String!) {
    page: datoCmsAbout(locale: { eq: $locale }) {
      title
      themeColor { hex }
      seo: seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }

    site: datoCmsSite {
      favicon: faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
    }

    about: datoCmsAbout(locale: { eq: $locale }) {
      title
      mainContent: mainContentNode {
        markdown: childMarkdownRemark {
          html
        }
      }
      teamTitle
      teamContent: teamContentNode {
        markdown: childMarkdownRemark {
          html
        }
      }
      teamImage {
        title
        alt
        sizes(maxWidth: 800, imgixParams: { auto: "compress" }) {
          ...GatsbyDatoCmsSizes
        }
      }
      officesTitle
      officesContent: officesContentNode {
        markdown: childMarkdownRemark {
          html
        }
      }
      officesImage {
        title
        alt
        sizes(maxWidth: 800, imgixParams: { auto: "compress" }) {
          ...GatsbyDatoCmsSizes
        }
      }
    }

    menuHomepage:           datoCmsHomepage(locale: { eq: $locale })           { menuTitle themeColor { hex } }
    menuInterchangeability: datoCmsInterchangeability(locale: { eq: $locale }) { menuTitle themeColor { hex } slug }
    menuPhilosophy:         datoCmsPhilosophy(locale: { eq: $locale })         { menuTitle themeColor { hex } slug }
    menuNews:               datoCmsNewsHome(locale: { eq: $locale })           { menuTitle themeColor { hex } slug }
    menuAbout:              datoCmsAbout(locale: { eq: $locale })              { menuTitle themeColor { hex } slug }
    menuContact:            datoCmsContact(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuCatalog:            datoCmsCatalog(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuDownload:           datoCmsDownloadArea(locale: { eq: $locale })       { menuTitle themeColor { hex } slug }
    menuDesigners:          datoCmsDesignersPage(locale: { eq: $locale })      { menuTitle themeColor { hex } slug }
    menuFooter:             datoCmsFooter                                      { facebook instagram twitter youtube pinterest companyName address: addressNode { markdown: childMarkdownRemark { html } } googleMapsUrl phoneNumber faxNumber vat emailAddress newsletterTitle newsletterDescription}
  }
`



// WEBPACK FOOTER //
// ./src/templates/about.js